import { render, staticRenderFns } from "./Yizhi.vue?vue&type=template&id=3bf19650&scoped=true&"
import script from "./Yizhi.vue?vue&type=script&lang=js&"
export * from "./Yizhi.vue?vue&type=script&lang=js&"
import style0 from "./Yizhi.vue?vue&type=style&index=0&id=3bf19650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf19650",
  null
  
)

export default component.exports